import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoSerieUpd = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoSerieUpd",
    params: {
      rnhFeriadoSerieId: data?.feriadoSerieId || null,
      // Number() porque el <select> entrega string — ver README del modulo.
      rnhFeriadoSerieFeriadoId: Number(data?.feriadoId) || null,
      rnhFeriadoSerieFecha: data?.fecha || null,
      // `?? null` y no `?? ''`: es lo que usan RNHFeriadoUpd/Del y el resto del modulo.
      // El `??` importa igual —la version de un registro recien creado es 0 y `||` la
      // convertiria en vacio—; esto es solo para que las cuatro sean iguales.
      rnhFeriadoSerieVersion: data?.version ?? null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
